import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import ToDoTemplateForm from "../ToDoTemplateForm";

export default function ToDoTemplateFormDialog({
  toDoTemplateId,
  onSubmit,
  initialToDoEvent = null,
  initialEventOccurrenceOffset = 0,
  readonly = false,
  ...disclosureProps
}) {
  return (
    <Dialog {...disclosureProps} maxWidth="md" fullWidth>
      <DialogTitle>
        {readonly ? "View" : toDoTemplateId ? "Edit" : "Add"} To-Do Item
      </DialogTitle>
      <DialogContent>
        <ToDoTemplateForm
          row={
            toDoTemplateId
              ? {
                  uuid: toDoTemplateId,
                }
              : null
          }
          onEdit={onSubmit}
          onCreate={onSubmit}
          initialToDoEvent={initialToDoEvent}
          initialEventOccurrenceOffset={initialEventOccurrenceOffset}
          readonly={readonly}
        />
      </DialogContent>
    </Dialog>
  );
}
